import { Stack, Typography } from '@mui/material';
import React from 'react';

import { TProjectCardRowProps } from '@/console/features/card-layout/components/recent-projects-card/components/project-card-row/project-card-row.types';
import { ConversionStatus } from '@/console/features/projects/components/conversion-status/conversion-status';
import { ProjectTypeTag } from '@/console/features/projects/components/project-type-tag/project-type-tag';
import { useProjectVersionNavigate } from '@/console/features/projects/hooks/use-project-version-navigate/use-project-version-navigate';
import { DevicesIcon } from '@/shared/assets/icons/devices-icon';
import { OpenIcon } from '@/shared/assets/icons/open-icon';
import { SearchableResourceField } from '@/shared/components/ui/searchable-resource-field/searchable-resource-field';
import { Vendor } from '@/shared/components/ui/vendor/vendor';
import { ProjectTypeEnum } from '@/shared/types/types.generated';

export const ProjectCardRow: React.FC<TProjectCardRowProps> = ({ project }) => {
  const versionId = project?.versions?.items[0]?.versionId;
  const { navigateToItem, onMouseEnter } = useProjectVersionNavigate(
    project.projectId,
    versionId,
  );

  return (
    <Stack
      onClick={navigateToItem}
      onMouseEnter={onMouseEnter}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack
        direction="column"
        justifyContent="space-between"
        gap="0.75rem"
        paddingY="0.25rem"
        width="300px"
      >
        <Stack gap="0.5rem" direction="row" alignItems="center">
          <SearchableResourceField
            value={project.name}
            queryParam="name"
            maxLength={30}
          />
          <ProjectTypeTag project={project} />
        </Stack>
        <Vendor vendorId={project.vendorId} ideConfigId={project.ideConfigId} />
      </Stack>
      {project.projectType !== ProjectTypeEnum.Library && (
        <ConversionStatus
          projectId={project.projectId}
          versionId={project?.versions?.items?.[0]?.versionId}
          vendorId={project.vendorId}
          ideConfigId={project.ideConfigId}
          projectType={project.projectType}
        />
      )}
      {project.projectType !== ProjectTypeEnum.Library && (
        <Stack
          direction="row"
          alignItems="center"
          gap="0.5rem"
          fontSize="0.75rem"
        >
          <DevicesIcon variant="primary" />
          <Typography variant="p3" fontWeight="bold">
            {project.linkedDevices.itemCount}
          </Typography>
        </Stack>
      )}
      <OpenIcon variant="light" />
    </Stack>
  );
};
